import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PopoverModule } from 'primeng/popover';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';

import { AddressBookComponent } from '../../components';

import { AppInsightsService } from '../../services/app-insights.service';
import { EmailService, IEmailRequest } from '../../services/insecta';

import { firstValueFrom } from 'rxjs';
import { notifyAndTrackError } from '../../common/error';

@Component({
  selector: `app-email`,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BreadcrumbModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    ChipModule,
    ContextMenuModule,
    CommonModule,
    DatePickerModule,
    DialogModule,
    EditorModule,
    FloatLabelModule,
    FieldsetModule,
    FormsModule,
    IconFieldModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputIconModule,
    InputNumberModule,
    InputTextModule,
    PopoverModule,
    RouterModule,
    SelectModule,
    TableModule,
    TabsModule,
    TextareaModule,
    ToggleSwitchModule,
    TreeSelectModule,
    TreeTableModule,
    AddressBookComponent
  ],

  templateUrl: `email.component.html`
})
export class EmailComponent implements OnDestroy, OnInit {
  private readonly appInsights = inject(AppInsightsService);
  private readonly emailService = inject(EmailService);
  private readonly msgService = inject(MessageService);

  @Input() show: boolean = true;
  @Output() showChange = new EventEmitter<boolean>();
  @Input() toList: string[] = [];
  @Input() ccList: string[] = [];
  @Input() subject: string = `New Email`;
  @Input() message: string = ``;

  pageVars = {
    visible: false
  };

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  onToListChange(list: string[]) {
    this.toList = list.map((entry) => entry.trim());
  }

  onCcListChange(list: string[]) {
    this.ccList = list.map((entry) => entry.trim());
  }

  onDiscardClick() {
    this.show = false;
    this.showChange.emit(this.show);
    this.resetForm();
  }

  onSendClick() {
    const request = <IEmailRequest>{
      to: this.toList,
      cc: this.ccList,
      subject: this.subject,
      message: this.message
    };

    firstValueFrom(this.emailService.sendEmail(request)).catch((err) => {
      notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'EmailComponent', action: 'SendEmail:Error' });
    });

    this.show = false;
    this.showChange.emit(this.show);
    this.resetForm();
  }

  resetForm() {
    this.toList = [];
    this.ccList = [];
    this.message = ``;
  }
}
